import {
  SidebarGroup,
  SidebarMenu,
  SidebarMenuItem,
  SidebarMenuButton,
} from "@components/ui/sidebar";
import { BarChart3Icon, BookmarkIcon, SearchIcon } from "lucide-react";
import { generatePath, Link } from "react-router-dom";
import { ROUTES } from "@/routes_new";
import { Trans } from "@lingui/react/macro";
import { FEATURE } from "@/features";
import { Feature } from "@components/Feature";
import AccessControl from "@components/AccessControl";

export function MainNav({
  orgUuid,
  pathname,
}: {
  orgUuid: string;
  pathname: string;
}) {
  const searchLink = generatePath(ROUTES.SEARCH_ORGID, { orgUuid });
  const reportsLink = generatePath(ROUTES.REPORTS_ORGID, { orgUuid });
  const favoritesLink = generatePath(ROUTES.FAVORITES_ORGID, { orgUuid });

  return (
    <SidebarGroup>
      <SidebarMenu>
        <AccessControl>
          <SidebarMenuItem>
            <SidebarMenuButton
              render={<Link to={searchLink} />}
              isActive={pathname.startsWith(searchLink)}
              id="create-new-alert-button"
              data-testid="explore-button"
            >
              <SearchIcon />
              <Trans>Sök</Trans>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </AccessControl>

        <Feature required={FEATURE.HAS_REPORT_PRODUCT}>
          <SidebarMenuItem>
            <SidebarMenuButton
              render={<Link to={reportsLink} />}
              isActive={pathname === reportsLink}
              id="reports-button"
              data-testid="reports-button"
            >
              <BarChart3Icon />
              <Trans>Rapporter</Trans>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </Feature>

        <SidebarMenuItem>
          <SidebarMenuButton
            render={<Link to={favoritesLink} />}
            isActive={pathname === favoritesLink}
            id="favorites-button"
            data-testid="favorites-button"
          >
            <BookmarkIcon />
            <Trans>Sparade omnämnanden</Trans>
          </SidebarMenuButton>
        </SidebarMenuItem>
      </SidebarMenu>
    </SidebarGroup>
  );
}
